/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '../../common/interfaces';

export enum DomainRegistrarsFormInputs {
  Name = 'name',
  Link = 'link'
}

export type DomainRegistrarFormFields = FormFields<typeof DomainRegistrarsFormInputs>;

export type DomainRegistrarFormValidationSchema = FormValidationSchema<DomainRegistrarFormFields>;

export enum DomainRegistrarAccountsFormInputs {
  Login = 'login',
  Password = 'password'
}

export type DomainRegistrarAccountFormFields = FormFields<typeof DomainRegistrarAccountsFormInputs>;

export type DomainRegistrarAccountFormValidationSchema = FormValidationSchema<DomainRegistrarAccountFormFields>;
